import { render } from "./WithLoader.vue?vue&type=template&id=1fe402bc&scoped=true&ts=true"
import script from "./WithLoader.vue?vue&type=script&lang=ts"
export * from "./WithLoader.vue?vue&type=script&lang=ts"

import "./WithLoader.vue?vue&type=style&index=0&id=1fe402bc&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe402bc"]])

export default __exports__